export enum NotificationMode {
  Digest = 'Digest',
  Instant = 'Instant',
  None = 'None',
}

export interface UserInterests {
  subscriptions: UserInterestSubscription[];
}

export interface UserInterestSubscription {
  mode: NotificationMode;
  modeResearch: NotificationMode;
  modeCovenants: NotificationMode;
  modeNews: NotificationMode;
  tags: string[];
  myCS: boolean;
  singleProductUI?: boolean;
}

export interface UserRole {
  label: string;
  code: string;
}

export interface UserWatchlist {
  id: string;
  name: string;
  tags: string[];
  myCs: boolean;
  createdAt: string;
  updatedAt: string;
}
